import styled from 'styled-components/native';

import Text from '@components/Text';

export const RobotImage = styled.Image`
  width: 224px;
  height: 224px;
`;

export const Container = styled.ScrollView`
  background: ${props => props.theme.colors.interaction.slot1};
  flex: 1;
`;

export const Content = styled.View`
  padding: 0px 10px;
  justify-content: center;
  align-items: center;
`;

export const RobotText = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot1};
  font-family: ${props => props.theme.fonts.weight[500]};
  padding-top: 10px;
`;

export const RobotTitle = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[400]};
  color: ${props => props.theme.colors.grayscale.slot1};
  padding-top: 4px;
  text-align: center;
`;

export const RobotSubtitle = styled(Text)`
  font-size: 14px;
  color: ${props => props.theme.colors.grayscale.slot1};
  padding-top: 12px;
  text-align: center;
`;

export const RobotBtn = styled.TouchableOpacity`
  background: ${props => props.theme.colors.grayscale.slot1};
  color: ${props => props.theme.colors.base.slot1};
  width: 100%;
  height: 50px;
  margin-top: 32px;
  border: none;
  font-size: 16px;
  border-radius: 46px;
  justify-content: center;
  align-items: center;
`;

export const RobotBtnText = styled(Text)`
  color: ${props => props.theme.colors.base.slot1};
  font-size: 14px;
`;
